import { ref } from 'vue'
import { projectFirestore } from '../firebase/config'


const useDocument = (collection, id) => {
  let error = ref(null);
  let isPending = ref(false);
  let docRef = projectFirestore.collection(collection).doc(id);

  const deleteDoc = async() => {
    error.value = null;
    isPending.value = true;
    try {
      const res = await docRef.delete();
      isPending.value = false;
      return res
    } catch(err) {
      console.log(err.message)
      isPending.value = false;
      error.value = 'Could not delete the document'
    }
  };


  const updateDoc = async (updates) => {
    error.value = null;
    isPending.value = true;
    try {
      const res = await docRef.update(updates);
      // 更新特定部分的資料，形式： { title: 'classics' }  物件形式，property: value
      // 由於songs是 array，加入新的song，若是直接寫：{ songs: [ newsong...] } 會直接將舊的也蓋掉
      // 因此需要把舊的和新的一起傳入
      isPending.value = false;
      console.log('pass');
      return res;
    } catch(err) {
      console.log(err.message)
      isPending.value = false;
      error.value = 'Could not add';
    }
  };
  return { error, isPending, deleteDoc, updateDoc }
}

export default useDocument